const LOGO_TYPES = {
  MERCH: 'merch',
  WHITE: 'white',
};

const isValidType = (type) => {
  const validValues = Object.values(LOGO_TYPES);

  return validValues.includes(type);
};

export default LOGO_TYPES;
export {isValidType};
